import React, { createContext, useContext } from 'react';

export interface CpBrandingPayload {
  displayName?: string | null;
  logoUrl?: string | null;
  primaryColor?: string | null;
  hasLogo?: boolean;
}

export interface CpPortalMirrorValue {
  mode: 'admin-mirror';
  clientId: number;
  companyName: string;
  clientCode: string;
  branding: CpBrandingPayload | null;
  onboardingPhase: string;
  role: string;
  revenueShareEnabled?: boolean;
  passthroughEnabled?: boolean;
}

export type CpPortalContextValue = CpPortalMirrorValue | null;

export const CpPortalContext = createContext<CpPortalContextValue>(null);

export function useCpPortalMirror(): CpPortalMirrorValue | null {
  const ctx = useContext(CpPortalContext);
  return ctx?.mode === 'admin-mirror' ? ctx : null;
}
